import {
  Box,
  Button,
  Checkbox,
  Divider,
  FormControlLabel,
  FormGroup,
  Typography,
  Grid,
  Link,
} from "@mui/material";
import GridLoader from "react-spinners/GridLoader";
import React, { useState } from "react";
import axios from "axios";
import moment from "moment";
import plans from "../plan-configuration.json";

function Review(props) {
  const removeAllConnectionsFromPersistenceTable = (userEmail) => {
    let url =
      "https://b3bq9zjyp4.execute-api.ap-southeast-2.amazonaws.com/api/";
    axios.delete(url + "connection/email/" + userEmail).then((response) => {});
  };
  const handleSignup = (event) => {
    setSignupSubmitted(true);

    const cafdata = [...props.cafDetails.cafState.connectionsCaf];
    let idDetails = { ...props.cafDetails.cafState };
    delete idDetails.connectionsCaf;

    const signups = cafdata.map((caf) => {
      let postCaf = {
        ...caf,
        ...idDetails,
        price_plan_code:
          caf.offering_code === "IO_SME_SB" ? "IO_SB_ELE3R_O" : "IO_SH_4RC_O",
      };
      return {
        raw_CAF: postCaf,
        phoneSignupRequested: false,
        sign_up_source: "self",
        agent_code: "",
      };
    });
    props.activeStepState.setActiveStep(4);

    fetch(
      "https://qclzqft32wxnrrxuicyam32fty0exmqb.lambda-url.ap-southeast-2.on.aws/",
      {
        method: "POST",
        headers: {},
        body: JSON.stringify({
          input: JSON.stringify(signups),
        }),
      }
    ).catch((err) => {
      alert(
        "There was an issue processing your signup. Please contact us to complete your signup."
      );
    });
    let userEmail = props.user.user[7].Value;
    removeAllConnectionsFromPersistenceTable(userEmail);
  };

  const [termsAndConditionsChecked, setTermsAndConditionsChecked] =
    useState(false);

  const toggleTermsAndConditionsChecked = () => {
    setTermsAndConditionsChecked(!termsAndConditionsChecked);
  };

  const [signupSubmitted, setSignupSubmitted] = useState(false);

  const renderAnswers = (flagIndex, flagOption, moveInDate = null) => {
    return (
      <>
        <Typography variant="body" hidden={flagOption === "I would like to"}>
          {flagOption === "true" ? "Yes" : "No"}
        </Typography>
        <Typography variant="body" hidden={flagOption !== "I would like to"}>
          I would like to
        </Typography>
        {flagIndex === 0 && flagOption === "true" ? (
          <Typography variant="body">, moving in on {moveInDate}</Typography>
        ) : null}
      </>
    );
  };

  return (
    <>
      {signupSubmitted ? (
        <GridLoader loading={!props.signupFinished.signupFinished} />
      ) : !props.signupFinished.signupFinished ? (
        <Box sx={{ mb: "50px" }}>
          <Typography variant="h2">Almost There!</Typography>
          <Typography variant="subtitle1" sx={{ mb: 1 }}>
            Review your details and sign up
          </Typography>

          <Box sx={{ my: 1, display: "block", overflow: "auto" }}>
            <Typography variant="body" sx={{ mb: 1 }} fontWeight="bold">
              Personal details
            </Typography>
          </Box>
          <Divider />

          <Box sx={{ display: "flex", my: 1 }}>
            <Typography variant="body" fontWeight={"600"}>
              Name:&nbsp;&nbsp;
            </Typography>
            <Typography variant="body">
              {props.user.user[5].Value} {props.user.user[6].Value}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", my: 1 }}>
            <Typography variant="body" fontWeight={"600"}>
              Mobile:&nbsp;&nbsp;
            </Typography>
            <Typography variant="body">{props.user.user[4].Value}</Typography>
          </Box>
          <Box sx={{ display: "flex", my: 1 }}>
            <Typography variant="body" fontWeight={"600"}>
              Email:&nbsp;&nbsp;
            </Typography>
            <Typography variant="body">{props.user.user[7].Value}</Typography>
          </Box>
          <Box sx={{ display: "flex", my: 1 }}>
            <Typography variant="body" fontWeight={"600"}>
              DOB:&nbsp;&nbsp;
            </Typography>
            <Typography variant="body">
              {props.user.identity.dob?.format("DD/MM/YYYY")}
            </Typography>
          </Box>
          <Box sx={{ display: "flex", my: 1 }}>
            <Typography variant="body" fontWeight={"600"}>
              ID Type:&nbsp;&nbsp;
            </Typography>
            <Typography variant="body">
              {props.user.identity?.idType}
            </Typography>
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography
              variant="body"
              sx={{ justifyContent: "space-between" }}
              fontWeight="bold"
            >
              Property details
            </Typography>
            <Button
              sx={{ float: "right" }}
              onClick={() => props.activeStepState.setActiveStep(1)}
            >
              Edit
            </Button>
          </Box>
          <Divider />

          <Box sx={{ mb: 2, display: "block" }}>
            {props.connections.map((item, index) => {
              return (
                <Box key={index}>
                  <Grid container justifyContent={"space-between"}>
                    <Typography variant="h5" sx={{ my: 1, display: "block" }}>
                      {plans[item.planName].shortName + " | "}
                      <Typography sx={{ color: "#8496A6", display: "inline" }}>
                        {item.address.description}
                      </Typography>
                    </Typography>
                  </Grid>
                  <Grid container>
                    {item.planName === "saSmartBusinessPlan" ? (
                      <Grid container display="block" rowSpacing={0.5}>
                        <Grid item>
                          <Typography
                            width="100%"
                            variant="body"
                            fontWeight="600"
                          >
                            Business Name
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography width="100%" variant="body">
                            {item.business_name}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            width="100%"
                            variant="body"
                            fontWeight="600"
                          >
                            Australian Business Number (ABN)
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography width="100%" variant="body">
                            {item.abn_number}
                          </Typography>
                        </Grid>
                      </Grid>
                    ) : null}
                    <Typography width="100%" variant="body" fontWeight="600">
                      Are you about to move in to this property?
                    </Typography>
                    <Grid container alignContent={"left"}>
                      {renderAnswers(
                        0,
                        item.moveInFlag,
                        item.moveInDate instanceof moment
                          ? item.moveInDate.format("DD/MM/YYYY")
                          : null
                      )}
                    </Grid>
                  </Grid>
                  <Grid container sx={{ my: 1 }}>
                    <Typography width="100%" variant="body" fontWeight="600">
                      Do you have a solar system installed at this site?
                    </Typography>
                    <Grid container alignContent={"left"}>
                      {renderAnswers(1, item.solarFlag)}
                    </Grid>
                  </Grid>
                  {item.planName !== "saSmartBusinessPlan" ? (
                    <>
                      <Grid container sx={{ my: 1 }}>
                        <Typography
                          width="100%"
                          variant="body"
                          fontWeight="600"
                        >
                          Does anyone at this property require life support
                          equipment?
                        </Typography>
                        <Grid container alignContent={"left"}>
                          {renderAnswers(null, item.lifeSupportFlag)}
                        </Grid>
                      </Grid>
                      <Grid container sx={{ my: 1 }}>
                        <Typography
                          width="100%"
                          variant="body"
                          fontWeight="600"
                        >
                          Does a resident at this property hold a concession
                          card?
                        </Typography>
                        <Grid container alignContent={"left"}>
                          {renderAnswers(null, item.concessionFlag)}
                        </Grid>
                      </Grid>
                    </>
                  ) : null}
                  <Divider hidden={index === props.connections.length - 1} />
                </Box>
              );
            })}
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <Typography variant="body" sx={{ mb: 1 }}>
              <b>Payment details</b>
            </Typography>
            <Button
              sx={{ float: "right" }}
              onClick={() => props.activeStepState.setActiveStep(2)}
            >
              Edit
            </Button>
          </Box>
          <Divider />
          <Box sx={{ mb: 2, display: "block" }}>
            {props.payment.useSamePaymentMethod ? (
              <Typography
                variant="body"
                fontWeight={"600"}
                sx={{ my: 1, display: "block" }}
              >
                Payment method
              </Typography>
            ) : null}

            {props.payment.useSamePaymentMethod ? (
              <Box>
                <Typography variant="body">
                  {props.payment.paymentDetails[0].bsb
                    ? "Direct Debit | BSB : " +
                      props.payment.paymentDetails[0].bsb +
                      " Account no. : " +
                      props.payment.paymentDetails[0].accountNumber
                    : "Manual payment on invoice receipt"}
                </Typography>
              </Box>
            ) : (
              props.payment.paymentDetails.map((item, index) => {
                return (
                  <Box key={index}>
                    <Typography variant="h5" sx={{ my: 1, display: "block" }}>
                      {props.connections[index].planName + " | "}
                      <Typography sx={{ color: "#8496A6", display: "inline" }}>
                        {props.connections[index].address.description}
                      </Typography>
                    </Typography>
                    <Typography variant="body" sx={{ my: 1, display: "block" }}>
                      {"Direct Debit | " + item.bsb + " " + item.accountNumber}
                    </Typography>
                  </Box>
                );
              })
            )}
          </Box>
          <Box sx={{ mb: 1 }}>
            <FormGroup>
              <FormControlLabel
                sx={{ pointerEvents: "none" }}
                control={
                  <Checkbox
                    sx={{ pointerEvents: "auto" }}
                    onChange={toggleTermsAndConditionsChecked}
                  />
                }
                label={
                  <Box
                    sx={{
                      display: "flex",
                      gap: 0.5,
                      flexWrap: "wrap",
                    }}
                  >
                    <Typography variant="body2">
                      I accept the{" "}
                      <Link
                        noWrap
                        target="_blank"
                        href="https://energylocals.com.au/terms-and-conditions/?_ga=2.200006702.1439639648.1596627248-2027481711.1596515158"
                        sx={{ pointerEvents: "auto" }}
                      >
                        Terms and Conditions
                      </Link>{" "}
                      and{" "}
                      <Link
                        noWrap
                        target="_blank"
                        href="https://uploads-ssl.webflow.com/60d2d620aa068132897f2159/61f1dbe35ffc5ccd57d343f4_200904%20IO%20Energy%20Privacy%20Policy.pdf"
                        sx={{ pointerEvents: "auto" }}
                      >
                        Privacy Policy
                      </Link>
                      , and agree to receive information from iO Energy
                      regarding their offers and services. You can opt out at
                      any time.
                    </Typography>
                  </Box>
                }
              />
            </FormGroup>
          </Box>
          <Button
            onClick={handleSignup}
            disabled={!termsAndConditionsChecked}
            variant="contained"
            id="submit-form"
            data-cy="submit-form"
            fullWidth
          >
            Finish & Signup
          </Button>
        </Box>
      ) : null}
    </>
  );
}

export default Review;
